"use client";

import { IconLayoutDashboard } from "@tabler/icons-react";
import type { ReactNode } from "react";
import BreadcrumbLink from "src/components/common/BreadcrumbLink/BreadcrumbLink";
import {
  ELEMENT_REFERENCES,
  type ElementReference,
  elementReferenceHref,
} from "src/lib/ElementReferences";
import { useTranslateText } from "#i18n";

export default function ElementLink({
  element,
  children,
  onClick,
}: {
  element: ElementReference;
  children?: ReactNode;
  /** Runs before navigation, e.g. to close the dialog the reference sits in. */
  onClick?: () => void;
}) {
  // Translated in the portal; the docs show the English label, as their Markdown export does.
  const translateText = useTranslateText();
  return (
    <BreadcrumbLink
      href={elementReferenceHref(element)}
      onClick={onClick}
      icon={ELEMENT_REFERENCES[element].id ? <IconLayoutDashboard aria-hidden /> : undefined}
    >
      {children ?? translateText(ELEMENT_REFERENCES[element].label)}
    </BreadcrumbLink>
  );
}
